var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYaraCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#11192A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.833 35.255c0 1.38-.991 2.5-2.214 2.5H3.048c-1.223 0-2.215-1.12-2.215-2.5v-32.5c0-1.38.992-2.5 2.215-2.5h22.209c.578 0 1.133.255 1.547.712l4.362 4.803c.427.47.668 1.116.667 1.79v27.695z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.833 12.755h-1.25c-1.283-.087-2.398.874-2.5 2.157v2.078c-.02.755-.446 1.44-1.113 1.793L6.333 20.3l2.637 1.515c.667.354 1.092 1.039 1.113 1.793v2.08c.102 1.282 1.217 2.243 2.5 2.155h1.25M18.833 12.755h1.25c1.284-.088 2.4.874 2.5 2.157v2.078c.02.755.446 1.44 1.114 1.793l2.636 1.517-2.636 1.515c-.667.354-1.092 1.039-1.114 1.793v2.08c-.102 1.282-1.217 2.243-2.5 2.155h-1.25",
    transform: "translate(1 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaraCode);
export default __webpack_public_path__ + "static/media/yara_code.2595a54fa8413cc85df8036ec227cae6.svg";
export { ForwardRef as ReactComponent };